// extracted by mini-css-extract-plugin
export default {"rating":"KI-z","numberOfStars":"LI-z","count":"MI-z","barGraphSpacing":"NI-z","barGraph":"OI-z"};